import { observer } from "mobx-react-lite";

import { ExpressionNode } from "@/components/expression/ExpressionNode";
import * as Node from "@/components/expression/utils/layout";
import { NodeStyleProvider } from "@/components/expression/utils/NodeStyleProvider";

import type { ExpressionComponent } from "@/components/expression/types";

export const PlaceholderNode: ExpressionComponent<"placeholder"> = observer(
  function PlaceholderNode({ node }) {
    if (!node.inlineNode) return null;

    const placeholderIndex = node.linkId?.codePointAt(0)
      ? String.fromCodePoint(node.linkId.codePointAt(0)!)
      : undefined;

    return (
      <Node.Container node={node} dimension="tight">
        <NodeStyleProvider
          placeholderVisible="cursored"
          labelPlaceholderVisible="cursored"
          placeholderIndex={placeholderIndex}
        >
          <ExpressionNode node={node.inlineNode} />
        </NodeStyleProvider>
      </Node.Container>
    );
  },
);
